






















import { ECustomerImportCampaignStatus } from '@/models/customer-import';
import { Component, Prop, Vue } from 'vue-property-decorator';

interface ICustomerImportCampaignStatusObj {
  nameIcon: string | null;
  tooltip?: string | null;
}

@Component({})
export default class CustomerImportCampaignStatus extends Vue {
  @Prop() status!: ECustomerImportCampaignStatus;

  get statusData(): ICustomerImportCampaignStatusObj {
    return {
      [ECustomerImportCampaignStatus.COMPLETED]: {
        nameIcon: 'icon-check-light',
        tooltip: this.translatedTooltip(ECustomerImportCampaignStatus.COMPLETED)
      },
      [ECustomerImportCampaignStatus.PENDING]: {
        nameIcon: 'icon-clock',
        tooltip: this.translatedTooltip(ECustomerImportCampaignStatus.PENDING)
      },
      [ECustomerImportCampaignStatus.SKIPPED]: {
        nameIcon: null,
        tooltip: this.translatedTooltip(ECustomerImportCampaignStatus.SKIPPED)
      },
      [ECustomerImportCampaignStatus.DROPPED]: {
        nameIcon: null,
        tooltip: this.translatedTooltip(ECustomerImportCampaignStatus.DROPPED)
      }
    }[this.status];
  }

  get classStatusIcon() {
    return this.statusData.nameIcon ? `icon ${this.statusData.nameIcon}` : '';
  }

  get fallBackDescription() {
    return !this.statusData.nameIcon ? '--' : null;
  }

  get tPrefix() {
    return 'customerImport.customersList.campaignStatus';
  }

  translatedTooltip(field: string) {
    const mapper: Record<string, string> = {
      [ECustomerImportCampaignStatus.DROPPED]: String(
        this.$t(`${this.tPrefix}.dropped`)
      )
    };

    return mapper[field] || null;
  }
}
